import styled, { css } from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
  display: grid;
  gap: 12px;
  grid-area: sidebar;
  grid-template-rows: min-content auto;
  left: ${({ open }) => (open ? "0" : "-100%")};
  padding: 20px;
  position: absolute;
  top: 72px;
  transition: 0.3s ease all;
  width: 100%;
  z-index: 10;
  height: calc(var(--app-height) - 72px);
  //overflow-x: auto;

  ${media.greaterThan("medium")`
    padding: 0;
    gap: 0;
    left: 0;
    top: 0;
    width: 248px;
    height: var(--app-height);
    position: fixed;
  `}
`;

export const CampaignSelectorWrapper = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: auto 1fr;
  padding: 18px 24px;
  width: 100%;

  cursor: pointer;

  ${media.greaterThan("medium")`
    display: grid;
  `}

  span {
    transition: 0.5s ease all;
    transform: ${({ open }) => (open ? "rotateX(180deg)" : "rotateX(0)")};
    align-self: center;
  }
`;

export const CampaignWrapper = styled.div`
  width: 100%;
  position: relative;
  display: none;

  ${media.greaterThan("medium")`
    display: block;
  `}
`;

export const Content = styled.div`
  display: grid;
  grid-gap: 32px;
  overflow-x: auto;
  padding-bottom: 32px;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.primary.cetaceanBlue};
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary.vividCerulean};

    :hover {
      background: ${({ theme }) => theme.colors.primary.vividCerulean};
    }
  }
`;

export const ItemsListWrapper = styled.div`
  ${({ bottom }) =>
    bottom &&
    css`
      align-self: flex-end;
    `}
`;

export const ToggleMenuTitle = styled.p`
  color: ${({ theme }) => theme.colors.neutral.white};
  ${({ theme }) => theme.font.body.xs};
  display: block;

  ${media.greaterThan("medium")`
    display: none;
  `}
`;

export const ItemWrapper = styled.div`
  width: 100%;
`;

export const Item = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.neutral.white};
  ${({ theme }) => theme.font.body.sm};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  display: flex;
  gap: 16px;
  padding: 16px 0 16px 36px;

  cursor: pointer;

  :hover {
    background-color: ${({ theme }) => theme.colors.hues.cetaceanShade1};
    color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
    transition: 0.3s ease all;

    svg {
      &:first-child {
        path {
          fill: ${({ theme }) => theme.colors.primary.cetaceanBlue};
        }
      }
    }

    > div:last-child {
      svg {
        path {
          fill: ${({ theme }) => theme.colors.neutral.white};
        }
      }
    }
  }
`;

export const ItemTitle = styled.div`
  display: flex;
  gap: 16px;
`;

export const ItemIcon = styled.div`
  padding: 5px;
  width: 100%;

  svg {
    align-self: center;
    transform: ${({ select }) => (select ? "rotateX(180deg)" : "rotateX(0)")};
    transition: 0.5s ease all;
  }
`;

export const ProfileWidgetWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
  border: 2px solid ${({ theme }) => theme.colors.neutral.gray8};
  border-radius: 8px;
  padding: 12px 15px;
  width: 100%;

  ${media.greaterThan("medium")`
    display: none;
  `}
`;

export const ButtonWrapper = styled.div`
  width: 100%;

  button {
    width: 100%;
  }

  ${media.greaterThan("medium")`
    display: none;
  `}
`;
